import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { TRANSACTION_VOLUME_BAR_CHART_DEFINITION } from './transaction-volume-bar-chart.definition';
import { TRANSACTION_VOLUME_BAR_CHART_MOCK_DATA } from './transaction-volume-bar-chart.mock';

export const TransactionVolumeBarChart = (props: ChartRendererProps) => (
    <BarChart
        {...props}
        stacked
    />
);

TransactionVolumeBarChart.definition = TRANSACTION_VOLUME_BAR_CHART_DEFINITION;
TransactionVolumeBarChart.mockData = TRANSACTION_VOLUME_BAR_CHART_MOCK_DATA;
